import { getOverviewLifetimePcConsole } from '@/pages/opinion/services';
import { useEffect, useState } from 'react';
import { dealwithPcConsoleState } from '../utils';
import { DBO_TM, DBO_V } from '@op/utils/format';
import _ from 'lodash-es';

const defaultStatsData = {
  opencritic: {},
  metacritic: {},
  steam: {},
};
export default function useGetPcConsoleStats({
  keepParams,
  needLink = false,
  channel = ['opencritic', 'metacritic', 'steam'],
}: {
  keepParams: any;
  needLink?: boolean;
  channel?: Array<'opencritic' | 'metacritic' | 'steam'>;
}) {
  const [userScore, setUserScore] = useState(
    JSON.parse(JSON.stringify(defaultStatsData)),
  );
  const [userScoreLoading, setUserScoreLoading] = useState(false);
  const [userScoreApiError, setUserScoreApiError] = useState(false);
  const requestUserScore = () => {
    setUserScoreLoading(true);
    setUserScoreApiError(false);
    const { channel: filterChannel, ...filter } = keepParams;
    getOverviewLifetimePcConsole({
      ...filter,
      channels: channel,
      need_link: needLink,
      is_today: DBO_TM.isToday(keepParams), // 前端判断是否是今天
    }).then((data: any) => {
      const globalResult = dealwithPcConsoleState(data);
      setUserScore(globalResult);
      setUserScoreLoading(false);
    });
  };

  useEffect(() => {
    if (keepParams && ['pc', 'console'].includes(keepParams.entity_type)) {
      requestUserScore();
    }
  }, [keepParams]);

  return {
    userScore,
    userScoreLoading,
    userScoreApiError,
  };
}

const valueKey: Array<'score' | 'review'> = ['score', 'review'];
type SteamItemType = { review: number; score: number; [key: string]: any };
export function dealwithSteamLinkDataInfo(
  data: {
    link_of_start_time: string;
    link_of_end_time: string;
    list: { [key: string]: SteamItemType };
    old_list: { [key: string]: SteamItemType };
    start_time: string;
    end_time: string;
    hour_link_of_time: {
      start_time: string;
      end_time: string;
      link_of_start_time: string;
      link_of_end_time: string;
    };
  },
  isToday: boolean,
) {
  const {
    list,
    old_list,
    link_of_start_time,
    link_of_end_time,
    start_time,
    end_time,
    hour_link_of_time,
  } = data || {};
  const result: { [key: string]: SteamItemType } = {};

  _.forOwn(list, (item: SteamItemType, key: string) => {
    const oldItem = old_list?.[key] || {};

    result[key] = valueKey.reduce((pre: any, key) => {
      const oldKey = `${key}_old`;
      const oldValue = oldItem[key] || 0;
      const qoqKey = `${key}_qoq`;
      return {
        ...pre,
        [oldKey]: oldValue,
        [qoqKey]: DBO_V.qoq(item[key], oldValue),
      };
    }, item || {});
  });

  if (isToday) {
    const { link_of_start_time, link_of_end_time, start_time, end_time } =
      hour_link_of_time || {};
    return {
      ...result,
      oldTime: [link_of_start_time, link_of_end_time],
      newTime: [start_time, end_time],
    };
  }

  return {
    ...result,
    oldTime: [link_of_start_time, link_of_end_time],
    newTime: [start_time, end_time],
  };
}
